import React, { useState, useCallback, useMemo } from 'react';

const DEFAULT_ALERT_DURATION = 3000;
const BILLING_ALERT_DURATION = 7000;

export const AlertContext = React.createContext();

export const AlertProvider = ({ children }) => {
    const [alerts, setAlerts] = useState([]);
    const [quotaAlert, setQuotaAlert] = useState(null);

    const showAlert = useCallback((type, content, alertProps = {}) => {
        const alert = {
            type,
            content,
            alertProps
        };

        setAlerts(prevState => [...prevState, alert]);

        alert.hide = () => {
            hideAlert(alert);
        }

        setTimeout(() => {
            hideAlert(alert);
        }, alertProps.duration || DEFAULT_ALERT_DURATION);

        return alert;
    }, [setAlerts]);

    const hideAlert = alert => {
        setAlerts(prevState => prevState.filter(item => item !== alert));
    }

    const showQuotaAlert = useCallback((type, data) => {
        setQuotaAlert({ type, data });

        setTimeout(() => {
            hideQuotaAlert();
        }, BILLING_ALERT_DURATION);
    }, [setQuotaAlert]);

    const hideQuotaAlert = useCallback(() => {
        setQuotaAlert(null);
    }, [setQuotaAlert]);

    const value = useMemo(() => ({
        alerts,
        showAlert,

        quotaAlert,
        showQuotaAlert,
        hideQuotaAlert
    }), [alerts, quotaAlert, showQuotaAlert]);

    return (
        <AlertContext.Provider value={value}>
            { children }
        </AlertContext.Provider>
    );
}
